import { useState, useEffect, useContext } from "react"
import { useNavigate } from "react-router-dom";
import finnHub from "../apis/finnHub"
import { BsFillCaretDownFill, BsFillCaretUpFill } from "react-icons/bs"
import { WatchListContext } from '../context/watchListContext';

export function StockList() {

  const [stock, setStock] = useState([])
  const { watchList } = useContext(WatchListContext)
  const navigate = useNavigate()

  function changeColor(change) {
    return change > 0 ? 'success' : 'danger'
  }

  function renderIcon(change) {
    return change > 0 ? <BsFillCaretUpFill /> : <BsFillCaretDownFill />
  }

  useEffect(() => {
    let isMounted = true
    async function fetchData() {
      try {
        const responses = await Promise.all(
          watchList.map((stock) => {
            return finnHub.get('/quote', {
              params: {symbol: stock}
            })
          })
        )
        const data = responses.map((response) => {
          return {
            data: response.data,
            symbol: response.config.params.symbol
          }
        })
        isMounted && setStock(data)
        // console.log(stock)
      } catch(err) {
        console.log(err)
      }
    }

    fetchData()
    return () => (isMounted = false)
  }, [watchList])

  function handleStockSelect(symbol) {
    navigate(`detail/${symbol}`)
  }

  return (
    <table className="table hover mt-5">
      <thead style={{color:'rgb(79,89,102)'}}>
        <tr>
          <th scope='col'>Name</th>
          <th scope='col'>Last</th>
          <th scope='col'>Change</th>
          <th scope='col'>Change %</th>
          <th scope='col'>High</th>
          <th scope='col'>Low</th>
          <th scope='col'>Open</th>
          <th scope='col'>Pclose</th>
        </tr>
      </thead>
      <tbody>
        {
          stock.map((stockData) => {
            return (
              <tr
                onClick={() => handleStockSelect(stockData.symbol)}
                style={{cursor:'pointer'}}
                className="table-row"
                key={stockData.symbol}
              >
                <th scope="row">{stockData.symbol}</th>
                <td>{stockData.data.c}</td>
                <td className={`text-${changeColor(stockData.data.d)}`}>{stockData.data.d} {renderIcon(stockData.data.d)}</td>
                <td className={`text-${changeColor(stockData.data.d)}`}>{stockData.data.dp} {renderIcon(stockData.data.d)}</td>
                <td>{stockData.data.h}</td>
                <td>{stockData.data.l}</td>
                <td>{stockData.data.o}</td>
                <td>{stockData.data.pc}</td>
              </tr>
            )
          })
        }
      </tbody>
    </table>
  )
}
